<script setup lang="ts">
import './assets/style.scss'
import { useInventLineCreateModal } from './../model/model.ts'
import { VModal, VSelectSearch } from '@/shared/ui'
import { computed, type PropType, ref } from 'vue'
import { useRoute } from 'vue-router'

const store = useInventLineCreateModal()

const props = defineProps({
  dependencies: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
})

/** Вычисляем значение фильтр */
const route = useRoute()
const objectId = computed(() => Number(route.params.object_id))

const loadFilter = computed(() => ({
  coords: store.pointCoords,
  types: props.dependencies,
  radius: 30,
}))

const { isLoading } = store.loadData(objectId, loadFilter)

const valid = ref(false)
</script>

<template>
  <VModal
    v-model="store.open"
    :title="$t(store.childObjects.length == 0 ? 'itf.set_start_point' : 'itf.set_end_point')"
  >
    <VForm v-model="valid" @submit.prevent="store.confirm">
      <VSelectSearch
        v-model="store.currentObject"
        :label="$t('itf.dependencies')"
        :rules="store.rules.currentObject"
        :items="store.objectList"
        :loading="isLoading"
        class="mt-2"
      />

      <div class="mt-2 form__btn_right">
        <VBtn color="default" variant="tonal" @click="store.cancel">
          {{ $t('itf.cancel') }}
        </VBtn>

        <VBtn type="submit">{{ $t('itf.add') }}</VBtn>
      </div>
    </VForm>
  </VModal>
</template>
